// src/components/plan/PlanRoutes.jsx
// Pooled inbox SP5 — the plan screens' addresses, mounted at /plan/* inside
// ProtectedRoutes(client) in App.js (R245): /plan (W2), /plan/payment and
// /plan/started (W3), /plan/card (W5) are added here, one task each. Any
// other /plan address lands on the dashboard.
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import OnboardingGate from "../onboarding/OnboardingGate";
import PlanCardPage from "./PlanCardPage";
import PlanChoosePage from "./PlanChoosePage";
import PlanPaymentPage from "./PlanPaymentPage";
import PlanStartedPage from "./PlanStartedPage";

export default function PlanRoutes() {
  return (
    <Routes>
      <Route
        index
        element={
          <OnboardingGate stageKey="intake">
            <PlanChoosePage />
          </OnboardingGate>
        }
      />
      <Route
        path="payment"
        element={
          <OnboardingGate stageKey="intake">
            <PlanPaymentPage />
          </OnboardingGate>
        }
      />
      <Route path="started" element={<PlanStartedPage />} />
      <Route path="card" element={<PlanCardPage />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
